import React, { useState } from 'react';
import { Container, Button, Toast, ToastContainer } from 'react-bootstrap';
import './Home.css';

function Home() {
    const [show, setShow] = useState(true);

    const toggleShow = () => setShow(!show);
    return (
            <div className="home-background text-center">
                {/* Hinweisstempel */}
                <a href='#buchung'>
                    <div className="sticker rounded-start">
                        INSTRUCTOR-Ausbildung:<br/>
                        <small>6 Tage ab</small> <b>1149,00 €</b><br/>
                    </div>
                </a>
                <div className="blur-section-black header-banner">
                    <h1 className="text-danger">KRAV MAGA</h1>
                    <h2>FRESENA AUSBILDUNGSZENTRUM</h2>
                </div>
            </div>
            );
}

export default Home;
